import api from 'Application/api/api';

const deleteActivity = (signal, id) =>
	api.delete(`/activity-templates/${id}`, {
		signal,
	});

export default deleteActivity;
